<template>
  <div id="news">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%"></div>
    <!--banner-->
    <div class="news-banner" v-for="(firstBanner,index) in firstBanner" :key="index">
       <span @click="windowOpen(firstBanner.url)">
            <img :src="firstBanner.picture">
       </span>
    </div>
    <!--新闻-->
    <div class="main">
      <div class="news-title">
        <span><el-icon class="el-icon-location-outline"></el-icon>首页-新闻动态-新闻内容</span>
      </div>
      <!--新闻详情-->
      <div class="main news-gj">
        <article class="news-details">
          <h3>{{form.title}}</h3>
          <h4><span>作者：{{form.author}}</span><span>日期：{{form.sendTime}}</span></h4>
          <p><span v-html="form.content"></span></p>
        </article>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import axios from 'axios'
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'
export default {
  data () {
    return {
      form: {},
      firstBanner: []
    }
  },
  created () {
    Api.changeClass = 2
    this.getFirstBanner()
    this.getDetail(this.$route.query.id)
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    },
    getFirstBanner () {
      axios.get(Api.bannerList + '?type=' + 2).then((response) => {
        this.firstBanner = response.data
      }, (response) => {
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    },
    getDetail (id) {
      if (id != null && id !== '') {
        let datas = {
          params: {
            id: id
          }
        }
        axios.get(Api.newsDetail, datas).then((response) => {
          this.form = response.data.data
          if (this.form.sendTime != null) {
            var now = new Date(this.form.sendTime)
            let y = now.getFullYear()
            let m = now.getMonth() + 1
            let d = now.getDate()
            this.form.sendTime = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + now.toTimeString().substr(0, 8)
          }
        }, (response) => {
          window.bus.$message({
            message: '请求超时，请检查网络',
            type: 'warning'
          })
        })
      }
    }

  }
}
</script>

<style>
  .nav-content {
    width: 100%;
    height: 80px;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .news-gj {
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .news-banner {
    width: 100%;
    height: 550px;
  }

  .news-banner img {
    width: 100%;
    height: 550px;
  }

  .main {
    width: 1200px;
  }

  .news-title {
    width: 100%;
    height: 55px;
    line-height: 55px;
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    background-color: #f62828;
    box-shadow: 3px 5px 10px -2px rgba(0, 0, 0, 0.3),
    -3px -5px 10px -2px rgba(0, 0, 0, 0.3);
    position: relative;
    top: 10px;
    text-align: left;
    padding-left: 20px;
  }
  .news-title i{
    margin-right: 5px;
  }
  .news-details{
    width: 100%;
    padding: 10px 30px;
  }
  .news-details h3{
    text-align: center;
    font-size: 18px;
  }
  .news-details p{
    text-indent: 2em;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }
  .news-details h4 span{
    font-size: 14px;
    color: #999;
    margin: 0px 20px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
  }
  .news-details img{
    width: 60%;
    height: auto;
    margin: 20px auto;
  }

  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }
  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsDetails.vue